import { Components, Theme } from '@mui/material';

const MuiSvgIcon: Components<Theme>['MuiSvgIcon'] = {
  variants: [
    {
      props: {
        color: 'inherit',
      },
      style: ({ theme }) => ({
        color: theme.palette.grey[600],
      }),
    },
  ],
};

export default MuiSvgIcon;
